import { lazy } from 'react'

type ComponentImportType<T extends React.ComponentType<any>> = () => Promise<{ default: T }>

const sessionKey = 'lazyWithRetry'

const lazyWithRetry = <T extends React.ComponentType<any>>(componentImport: ComponentImportType<T>, name: string) => {
  return lazy<T>(async () => {
    const hasRefreshed = globalThis.sessionStorage.getItem(`${sessionKey}-${name}`) || 'false'

    try {
      globalThis.sessionStorage.setItem(`${sessionKey}-${name}`, 'false')
      return await componentImport()
    } catch (error) {
      if (hasRefreshed === 'false') {
        globalThis.sessionStorage.setItem(`${sessionKey}-${name}`, 'true')
        window.location.reload()
      }

      if (hasRefreshed === 'true') throw new Error('chunkLoadError')

      return await componentImport()
    }
  })
}

export default lazyWithRetry
